export default __webpack_public_path__ + "static/media/pancake-swap.59b74e24.jpg";